<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="8">
        <!-- <b-form-input
          size="sm"
          class="mr-sm-2"
          type="text"
          placeholder="Search"
          @keyup="filterList"
          v-model="searchString"
        />-->
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="1">
        <i
          v-b-tooltip
          title="Download Territories"
          class="fa fa-download fa-lg mt-2 pt-1 mr-3 float-right clickIcon"
          style="color: #333;"
          @click="download_territories"
        ></i>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="newEntity"
          >
            <i class="fa fa-address-card-o"></i>
            New Territory
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="Territory"
          >
            <div slot="header">
              <h2>{{ mySelected.TerritoryName }}</h2>
              <!-- <h4>{{mySelected.Email}}</h4>
              <h4>{{mySelected.Phone1}}</h4>-->
            </div>
            <div slot="details">
              <div></div>
            </div>
            <span slot="entityType">Territory</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "TerritoryList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },

        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true,
          thStyle: "width: 45%;"
        },
        {
          key: "ZipTotal",
          label: "Total",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "IsProtected",
          label: "Protected",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "ManagedBy.UserName",
          label: "Assigned To",
          sortable: true,
          thStyle: "width: 30%;"
        }
      ],
      mySelected: { Territory: {} },
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  components: {
    cTable,
    StyledDialog
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.territory.territories.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.territory.territories;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "territory", "n_user", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {
      this.filterList();
    }
  },
  methods: {
    download_territories() {
      this.$store
        .dispatch("territory/DownloadTerritories")
        .then(response =>
          window.open(
            "http://rm_api.revolutionterritorymanager.com/Output/" +
              response.data,
            "_blank"
          )
        );
    },

    async myLoadComponent() {
      await this.$store.dispatch("territory/fetchTerritories");
      this.filterList();
      await this.$store.dispatch("zip/fetchZipSymbols");
      await this.$store.dispatch("zip/fetchRotationZipSymbols");
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.territory.territories.filter(
        territory =>
          territory.TerritoryName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          territory.CenterZip.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          territory.ManagedBy.UserName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("territory/loadTerritoryEdit", record.TerritoryID)
        .then(() => {
          this.$router.push({ name: "Territory" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("territory/newTerritory", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Territory" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    createFreshObject() {
      return {
        TerritoryID: -1,
        IsProtected: false,
        UserProfileID: this.$store.state.n_user.n_current_user.UserProfileID,
        Rotations: [],
        DefaultRadius: 25,
        TerritoryColor: "#FF0000",
        TerritoryName: "",
        CenterZip: "",
        Zips: []
      };
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
